import { render } from "./table.vue?vue&type=template&id=3e66e142&scoped=true"
const script = {}

import "./table.vue?vue&type=style&index=0&id=3e66e142&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e66e142"]])

export default __exports__